module.exports = __webpack_public_path__ + "img/IMG_9432_L_WoodMatted.6765d539.jpg";